module.exports = __webpack_public_path__ + "img/steps2-1.en.e523c7a8.png";